import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutsModule } from 'src/app/layouts/layouts.module';
import { UiShowcaseComponent } from './main/ui-showcase.component';

// dashboard
const routes: Routes = [
	{
		path: '',
		component: UiShowcaseComponent,
		data: { title: 'UI-Showcase' }
	}
];

@NgModule({
	imports: [LayoutsModule, RouterModule.forChild(routes)],
	providers: [],
	exports: [RouterModule]
})
export class UiShowcaseRoutingModule {}
